import React from 'react';
import { graphql } from 'gatsby';

import SEO from '../components/SEO';
import Checkout from '../components/Checkout';

const CheckoutPage = props => {
  const { data } = props;

  return (
    <>
      <SEO title="Checkout" />
      <Checkout data={data} />
    </>
  );
};

export default CheckoutPage;

export const query = graphql`
  query CheckoutQuery {
    allBillingPreference {
      edges {
        node {
          billingPreferenceKey
          billingPreferenceDesc
          billingPreferencePrice
          billingPreferenceTitle
        }
      }
    }
    allErrorMessage {
      edges {
        node {
          ...AemComponentsFragment
        }
      }
    }
    allVariableConfig {
      edges {
        node {
          name
          value
        }
      }
    }
  }
`;
